module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isMobile) ? _c('div', {
    staticClass: "settings-wrapper"
  }, [_c('div', {
    staticClass: "settings-btn",
    on: {
      "click": _vm.toggleMenu,
      "touchstart": function($event) {
        $event.stopPropagation();
      },
      "touchmove": function($event) {
        $event.stopPropagation();
      },
      "touchend": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._v("\n    ⚙️ 设置\n  ")]), _vm._v(" "), (_vm.showMenu) ? _c('div', {
    staticClass: "settings-menu",
    on: {
      "touchstart": function($event) {
        $event.stopPropagation();
      },
      "touchmove": function($event) {
        $event.stopPropagation();
      },
      "touchend": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "menu-header"
  }, [_c('span', [_vm._v("菜单")]), _vm._v(" "), _c('span', {
    staticClass: "close-btn",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_vm._v("❌")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-content"
  }, [_c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.triggerAction('r')
      }
    }
  }, [_vm._v("🔄 重置游戏")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        _vm.triggerAction('s')
      }
    }
  }, [_vm._v("🔊 音效: " + _vm._s(_vm.music ? '开' : '关'))]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    on: {
      "click": _vm.toggleControlMode
    }
  }, [_vm._v("🕹️ 操控模式: " + _vm._s(_vm.controlMode === 'button' ? '按键' : '触屏'))]), _vm._v(" "), _c('div', {
    staticClass: "menu-item score-title"
  }, [_vm._v("🏆 当前分数: " + _vm._s(_vm.points))])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5cea9dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/index.vue
// module id = 180
// module chunks = 1